<template>
  <Breadcrumbs title="" main="Home" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card" v-if="this.team_obj">
          <div class="card-header" v-if="this.team_obj.cover_url">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img
                  style="
                    width: 100%;
                    box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);
                    border-bottom-left-radius: 0.6em;
                    border-bottom-right-radius: 0.6em;
                    border: 0px;
                  "
                  :src="this.team_obj.cover_url"
                  class="img-thumbnail"
                />
              </figure>
            </div>

            <h3 style="padding-left: 10px; padding-top: 10px">
              {{ this.team_obj.team_name }}
              <a :href="this.team_obj.team_facebook_url" target="_blank"
                ><img
                  style="height: 30px"
                  src="../../assets/images/running/facebook-icon.png"
              /></a>
            </h3>
            <span
              style="padding-left: 10px;font-size: medium;"
              v-html="this.team_obj.team_description"
            ></span>
            <hr />
          </div>

          <div class="card-body" itemscope="">
            <div v-if="loading" class="d-flex justify-content-center">
              <img
                style="align-items: center; width: 30px"
                src="../../assets/images/running_loading.svg"
              />
            </div>
            <div 
              class="my-gallery card-body row gallery-with-description"
              itemscope=""
              v-else
            >
              <figure
                class="col-xl-4 col-sm-6"
                v-for="(src, index) in this.events_on_sale"
                :key="index"
                style="position: relative"
              >
                <a v-bind:href="`/` + src.event_key" target="_blank">
                  <img
                    style="
                      border-top-left-radius: 0.6em;
                      border-top-right-radius: 0.6em;
                      border: 0px;
                      filter: drop-shadow(0 -1mm 4mm rgb(0, 0, 0, 20%));
                    "
                    :src="src.coverurl"
                    alt="Image description"
                    class="img-thumbnail"
                  />

                  <i
                    v-if="src.pin === 1"
                    class="fa fa-thumb-tack"
                    style="
                      position: absolute;
                      top: -5px;
                      right: 15px;
                      color: red;
                      font-size: 2.2em;
                      z-index: 10;
                      transform: rotate(30deg);
                      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
                    "
                  ></i>

                  <div
                    class="caption"
                    style="
                      box-shadow: 0 0em 1em rgb(0 0 0 / 50%);
                      border-bottom-left-radius: 0.6em;
                      border-bottom-right-radius: 0.6em;
                      border: 0px;
                    "
                  >
                    <h4>{{ src.title }}</h4>
                    <b
                      ><i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                      {{ src.event_date_text }}</b
                    >
                    <p>
                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                      {{ src.eventdate }} {{ src.province }}
                    </p>
                  </div>
                </a>
              </figure>
              <paginate
                v-if="this.total_event_onsale > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="4"
                :clickHandler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center pagination-sm'"
                :page-class="'page-item'"
              >
              </paginate>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <div class="card" v-if="!this.team_obj">
          <span>Team not found!</span>
        </div>
      </div>
    </div>
    <p>&nbsp;</p>
  </div>
</template>
<style scoped>
.modern-image {
  border-radius: 8px; /* ปรับค่าตามต้องการ */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* ปรับค่าตามต้องการ */
  transition: box-shadow 0.3s ease-in-out; /* เพิ่ม transition เพื่อความสมูทเมื่อมี interaction (optional) */
}

.modern-image:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); /* เงาเข้มขึ้นเล็กน้อยเมื่อ hover (optional) */
}
</style>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

import { useCartStore } from "../../store/modules/cart";
import axios from "axios";
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
import VuejsPaginateNext from "../../components/Paginate.vue";
export default {
  components: {
    paginate: VuejsPaginateNext,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const siteData = reactive({
      title: process.env.VUE_APP_SYSTEM_TITLE || '',
      description: process.env.VUE_APP_SYSTEM_DESCRIPTION || ``,
      keywords: process.env.VUE_APP_SYSTEM_KEYWORDS ||   ``,
      image:  process.env.VUE_APP_WEBSITE_IMAGE || '',
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    })

    const cart_store = useCartStore();
    cart_store.loadFromLocalStorage();
    return {
      cart_store,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      swiperOptions: {
        //breakpoints: { slidesPerView: 1 } ,
        loop: true,
      },
    };
  },
  data() {
    return {
      modules: [Pagination, Autoplay],
      team_obj: {},
      events_on_sale: [],
      events_soon: [],
      loading: true,
      page: 1,
      init_page_size: 36,
      page_tab: 0,
      total_event_onsale: 0,
      currentLanguage: "th",
      slider_banner: [],
    };
  },

  async created() {
    this.currentLanguage = localStorage.getItem("currentLanguage");
    this.team_obj = await this.getTeamDetail();
    let result = await this.getEvents();
    if (result.status === "success") {
      this.events_on_sale = result.body;
      this.loading = false;
    } else {
      this.loading = false;
      alert("พบข้อผิดพลาด ลองใม่อีกครั้ง");
    }
  },
  async mounted() {
    this.currentLanguage = localStorage.getItem("currentLanguage");
  },

  methods: {
    async getEvents() {
      const res = await axios.get(
        "/v1/events/team/" + this.$route.params.team_key,
        null
      );
      return res.data;
    },
    async getTeamDetail() {
      const res = await axios.get(
        "/v1/events/team-detail/" + this.$route.params.team_key,
        null
      );
      return res.data.body[0];
    },
    async getSliderBanner() {
      const res = await axios.get("/v1/events/slider-banner");
      console.log(res.data);
      this.slider_banner = res.data.body;
    },
  },
};
</script>


    